<script lang="ts">
	import { page } from '$app/state';
	import Callout from '$lib/component/navigation/Callout.svelte';
	import H from '$lib/html/h/H.svelte';
</script>

<!-- BG image error.webp -->

<div
	class="flex items-center justify-center w-screen h-[100dvh] bg-secondary text-secondary-on text-center relative"
>
	<div>
		<H level="1">Hummm...</H>
		<H level="2">Something wrong happened</H>
		<div class="z-50">
			<Callout color="error" className="mt-4 text-left z-10" icon="laptopBroken">
				<div>
					<div class="text-3xl">{page.status}</div>
					<div>{page.error?.message}</div>
				</div>
			</Callout>
			<div class="mt-4">
				Go to
				<a href="/" class="text-primary">home page</a>
				or
				<button class="text-primary" onclick={() => history.back()}>back page</button>
				or
				<a href="/logout" class="text-primary">logout</a>
			</div>
		</div>
	</div>
</div>
